import React, { useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import TextEditor from '@/views/elements/TextEditor';
import { TextContext } from '@/utils/contexts/TextContext';
import Spinner from '@/views/components/Spinner/Spinner';

import styles from '@/views/pages/Letter/elements/LetterPopover/LetterPopover.module.scss';

const SingleChangeEditModule = (props) => {
	const { onEditCancel, onEditAccepted, changeId, change: { content: chngContent, footnote, motivation }, changeType } = props;
	const dict = useSelector((state) => state.app.dict);

	const { contextState } = useContext(TextContext);

	const [ content, setContent ] = useState('');
	const [ annotation, setAnnotation ] = useState('');
	const [ reason, setReason ] = useState('');

	const handleAddChange = () => {
		onEditAccepted({ content, annotation, reason }, changeId);
	};

	return (
		<>
			{contextState.requestPending &&
                (<div className={ styles['letter-popover--spinner'] }><Spinner wrapper /></div>)}
			{ changeType === 'change' && <TextEditor
				placeholder={ dict.letter.editor.changeContent }
				setFieldContent={ setContent }
				minHeight={ 100 }
				setAutoFocus
				defaultText={ chngContent ? chngContent : '' }
			/> }
			{ changeType === 'footnote' && <TextEditor
				placeholder={ dict.letter.editor.annotation }
				setFieldContent={ setAnnotation }
				defaultText={ footnote ? footnote : '' }
			/> }
			<div className={ `${ styles['letter-popover__changes--header'] } ${ styles['top'] }` }>
				{dict.letter.popover.reason} <span className={ styles['letter-popover__changes--optional'] }>{dict.letter.popover.reasonOptional}</span>
			</div>
			<TextEditor
				placeholder={ dict.letter.editor.reason }
				setFieldContent={ setReason }
				disableFormating
				defaultText={ motivation ? motivation : '' }
			/>
			<div className={ styles['letter-popover--buttons'] }>
				<div
					className='button__std'
					onClick={ () => onEditCancel() }
				>{dict.cancel}
				</div>
				<div
					className={ `${ styles['letter-popover--btn'] } noselect${(content.replace(/(<([^>]+)>)/ig, '').length < 1) && ' disabled'}` }
					onClick={ () => handleAddChange() }
				>
					{dict.letter.popover.simplify}
				</div>
			</div>
		</>
	);
};
export default SingleChangeEditModule;